<template id="vue-height">
  <PageContainer>
    <div class="page-content">
      <div class="title animated">What is your height?</div>
      <div class="content">
        <div class="col-xs-12" :class="{'hidden': !this.useInches}">
          <div class="height-inline">
            <label>
              <input
                class="desktopInput"
                :class="feetNumberError ? 'error' : ''"
                type="text"
                v-model="feet"
                v-on:keyup="focusInput($event, 'inchesInputDesktop')"
              />
              <input
                class="mobileInput"
                :class="feetNumberError ? 'error' : ''"
                type="number"
                v-model="feet"
                v-on:keyup="focusInput($event, 'inchesInputMobile')"
              />
              <span class="weight-unit-label">ft</span>
            </label>
          </div>
          <div class="height-inline height-inline-2">
            <label>
              <input
                class="desktopInput"
                :class="inchesNumberError ? 'error' : ''"
                type="text"
                v-model="inches"
                id="inchesInputDesktop"
              />
              <input
                class="mobileInput"
                :class="inchesNumberError ? 'error' : ''"
                type="number"
                v-model="inches"
                id="inchesInputMobile"
                v-on:keyup.enter="closeMobileKeyboard"
              />
              <span class="weight-unit-label">in</span>
            </label>
          </div>
        </div>
        <div>
          <div class="height-cm-inline" :class="{'hidden': this.useInches}">
            <label>
              <input
                class="desktopInput"
                :class="centimetersNumberError ? 'error' : ''"
                type="text"
                v-model="centimeters"
              />
              <input
                class="mobileInput"
                :class="centimetersNumberError ? 'error' : ''"
                type="number"
                v-model="centimeters"
              />
              <span class="weight-unit-label">cm</span>
            </label>
          </div>
        </div>
        <div class="col-xs-12">
          <button
            id="prefer-text"
            class="btn-link info-block"
            @click="toggleUnits"
          >I prefer {{oppositeUnits}}</button>
        </div>
      </div>

      <p class="info-block" v-if="numbersError">Please enter your height in numbers only</p>
      <p class="info-block" v-if="feetNumberError">Please enter a number between 3 and 7.</p>
      <p class="info-block" v-if="inchesNumberError">Please enter a number between 0 and 11.</p>
      <p class="info-block" v-if="centimetersNumberError">Please enter a real value.</p>
    </div>

    <div class="footer-container">
      <ButtonNext :onClick="updateHeight" :isDisabled="invalidForm || disabled" :text="'Next'" />
      <ProgressBar />
    </div>
  </PageContainer>
</template>

<script>
import ProgressBar from '../../shared/components/ProgressBar';
import Trackeable from '../../Trackeable';
import Globalized from '../../shared/components/Globalized';
import { navigateTo, ROUTE_NAMES } from '../router';
import PageContainer from '../../shared/components/PageContainer';
import ButtonNext from '../../shared/components/ButtonNext';
import ProgressFull from '../mixins/ProgressFull';

const NUMBERS_REGEX = /^[0-9.,]+$/;
const ENTER_KEY = 13;

export default {
  name: 'height',
  components: {
    ButtonNext,
    ProgressBar,
    PageContainer
  },
  mixins: [Trackeable, Globalized, ProgressFull],
  template: '#vue-height',
  data: function() {
    return {
      feet: this.$store.state.nyop.feet,
      inches: this.$store.state.nyop.inches,
      centimeters: `${this.$store.state.nyop.feet || ''}${this.$store.state.nyop.inches || ''}`,
      useInches: this.$store.state.nyop.heightUnit === 'in',
      disabled: null
    };
  },
  computed: {
    oppositeUnits: function() {
      return this.useInches ? 'centimeters' : 'inches';
    },
    numbersError: function() {
      return (
        isNaN(this.feet) ||
        isNaN(this.inches) ||
        isNaN(this.centimeters) ||
        invalidNumber(this.feet) ||
        invalidNumber(this.inches) ||
        invalidNumber(this.centimeters)
      );
    },
    feetNumberError: function() {
      return this.feet && this.useInches && (this.feet < 3 || this.feet > 7);
    },
    inchesNumberError: function() {
      return (
        this.inches && this.useInches && (this.inches < 0 || this.inches > 11)
      );
    },
    centimetersNumberError: function() {
      return !this.useInches && this.centimeters && (this.centimeters < 100 || this.centimeters > 250);
    },
    invalidForm: function() {
      return (
        (this.useInches && (!this.feet || !this.inches)) || (!this.useInches && !this.centimeters) ||
        this.numbersError ||
        this.feetNumberError ||
        this.inchesNumberError ||
        this.centimetersNumberError
      );
    }
  },
  created: function() {
    this.disabled = null;
  },
  methods: {
    updateHeight: function() {
      this.disabled = 'disabled';
      const height = {}
      height.feet = this.useInches ? this.feet : this.centimeters[0]
      height.inches = this.useInches ? this.inches : `${this.centimeters[1]}${this.centimeters[2]}`
      height.heightUnit = this.useInches ? 'in' : 'cm'

      this.$store.commit('updateHeight', height);
      navigateTo(this.$router, ROUTE_NAMES.Weight);
    },
    toggleUnits: function() {
      this.useInches = !this.useInches;
    },
    focusInput: function(event, id) {
      if (!this.feetNumberError && !isNaN(Number(event.key))) {
        document.getElementById(id).focus()
      }
    },
    closeMobileKeyboard: function(event) {
      if (event.keyCode === ENTER_KEY) { event.target.blur() } // hide mobile keyboard on clicking "Go"
    }
  }
};

function invalidNumber(value) {
  return value && !value.match(NUMBERS_REGEX);
}
</script>
